import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeleteLinksMutation } from "../graphql/mutations";
import type {
  DeleteLinksMutationType,
  DeleteLinksMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useDeleteLinksMutation = (
  options?: MutationHookOptions<
    DeleteLinksMutationType,
    DeleteLinksMutationVariablesType
  >
) => {
  return useMutation<DeleteLinksMutationType, DeleteLinksMutationVariablesType>(
    DeleteLinksMutation,
    options
  );
};
